module.exports = __webpack_public_path__ + "static/img/5.eb97966.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/5.png
// module id = qjhx
// module chunks = 0